var map = {
	"./Quiz1Data": [
		4544,
		544
	],
	"./Quiz3Data": [
		3880,
		880
	],
	"./Quiz4Data": [
		8833,
		833
	],
	"./Quiz5Data": [
		7910,
		910
	],
	"./Quiz6Data": [
		8301,
		301
	],
	"./Quiz7Data": [
		6928,
		928
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8372;
module.exports = webpackAsyncContext;